<template>
    <span class="arrow pointer" data-direction="direction" @click="changeDate(amount)" :disabled="disabled">
        <span :class="['ico-arrow-' + direction]"></span>
    </span>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'

    export default {
        props: {
            amount: String,
            direction: String,
            disabled: Boolean,
            calendarApi: {
                type: Object,
                default: null,
            },
        },
        computed: {
            ...mapGetters([
                'getExpandedDay',
                'getCurrentView',
            ])
        },
        methods: {
            ...mapActions([
                'updateExpandedDate',
                'updateSidebar'
            ]),

            // Increments / decrements the currently selected date
            changeDate: function(amount) {
                if (this.disabled) return false;

                var oldDate = this.getExpandedDay;
                var newDate;

                if (this.getCurrentView == 'month') {
                    newDate = this.formatDate(moment(this.getExpandedDay).add(this.amount, 'months'));
                } else if (this.getCurrentView == 'agendaWeek') {
                    newDate = this.formatDate(moment(this.getExpandedDay).add(this.amount, 'weeks'));
                } else {
                    newDate = this.formatDate(moment(this.getExpandedDay).add(this.amount, 'days'));
                }

                this.updateExpandedDate(newDate);

                if (this.calendarApi) {
                    this.calendarApi.gotoDate(newDate);
                }

                this.updateSidebar(newDate);

                // Trigger an update on the events list in case we don't have the
                // selected day filled with data from the API
                this.$emit('updateArrowDate', newDate);

                // Push new route parameters
                let viewToURL = '';
                switch (this.getCurrentView) {
                    case 'agendaDay':
                        viewToURL = 'day'
                        break;
                    case 'agendaWeek':
                        viewToURL = 'week'
                        break;
                    default:
                        viewToURL = this.getCurrentView;
                }

                this.$router.push({ name: 'calendarExpanded', params: { currentView: viewToURL, expandedDay: newDate } });
            },
        }
    }
</script>


// WEBPACK FOOTER //
// Arrow.vue?c8e577e8